


import { Box, Typography, IconButton, TextField, FormControlLabel, Checkbox } from "@mui/material";
import { enqueueSnackbar } from "notistack";
import { DataTable } from "primereact/datatable";
import React, { useEffect, useRef, useState } from "react";
import { Popover, FormGroup, Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { getIndentsTemplateDataList, getListOfIndentsWithProjects } from "../api/Services/masterServie";
import ReusablePrimeButton from "../Component/Buttons/ReusablePrimeButton";
import ReusableDataTable from "../Component/DataTable/ReusableDataTablePrime";
import { indentBodyTableIcon, getIndentsColumns, getIndentsTemplateData, getIndentsTemplateColumns, indentsTemplateTableIcon } from "../const/AssertData";
import { CustomMessage } from "../const/Spinner";
import { setLoading } from "../store/CommonSlice";
import { RootState } from "../store/Reduxstore";
import { IndentFormData } from "../types/assetTypes";
import CreatingIndentsTemplate from "./StockManagement/CreatingIndentsTemplate";




interface IndentsProps {
  setPathname: (path: string) => void;
}
const IndentsMain: React.FC<IndentsProps> = ({
  setPathname,
}) => {
  const dt = useRef<DataTable<any[]>>(null);
  const dispatch = useDispatch();

  const [selectedStage, setSelectedStage] = useState<string>("stage1");
  const [indentTemplateId, setIndentTemplateId] = useState<number | null>(null);
  interface AssetOption {
    label: string;
    value: string;
  }

  const [indentPrimaryId, setIndentPrimaryId] = useState<number | null>(null);
  useEffect(() => {
    if (indentPrimaryId) {
      console.log("indentPrimaryId updated in state:", indentPrimaryId);
    }
  }, [indentPrimaryId]);


  const [searchText, setSearchText] = useState("");
  const [selectedData, setSelectedData] = useState<IndentFormData>({
    indentId: 0,
    username: "",
    indentNo: 0,
    countryName: "",
    currentLocationId: 0,
    requestTo: "",
    requestToId: 0,
    requestFromId: 0,
    requestFrom: "",
    address: "",
    mapLocation: "",
    date: "",
    defaultList: "",
    notify: "",
    notes: "",
    userId: 0,
    indentPrimaryId: 0,
    section: [],
    status: 0,
    userIds: []
  });


  const userDetails = useSelector((state: RootState) => state.auth);
  const [userId, setUserId] = useState<number>(userDetails.userId); // default to 0 or null
  console.log("details:", userDetails);
  type ViewType = "all" | "drafts" | "submitted";

  useEffect(() => {
    if (userDetails?.userId) {
      setUserId(userDetails.userId);
    }
  }, [userDetails?.userId]);



  const [products, setProducts] = useState<IndentFormData[]>([]);
  const [currentViewType, setCurrentViewType] = useState<ViewType>("all");
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (!open) {
      setSelectedStage("stage1");
    }
  }, [open]);

  const [selectedProducts, setSelectedProducts] = useState<any[]>([]);
  const [paginationData, setPaginationData] = useState<{
    page: number;
    rows: number;
    totalRecords: number;
  }>({
    page: 1,
    rows: 13,
    totalRecords: 0,
  });

  console.log(userDetails);
  const actionBodyTemplate = (rowData: IndentFormData) => {
    const renderIconData = indentsTemplateTableIcon(
      handleEditIndents, rowData,
    );
    return (
      <>
        {renderIconData &&
          renderIconData.map((val, index) => (
            <ReusablePrimeButton key={index} {...val} />
          ))}
      </>
    );
  };
  const columns = getIndentsTemplateColumns(actionBodyTemplate);

  const [filterData, setFilterData] = useState<Record<string, any>>(() =>
    (columns ?? []).reduce((acc, col) => {
      if (col.field) {
        acc[col.field] = { value: "", matchMode: "startsWith" }; // Ensure correct structure
      }
      return acc;
    }, {} as Record<string, { value: string; matchMode: string }>),
  );




  const handleClearFilter = () => {
    // Clear filters and related UI states
    setFilterData({});


    // Refetch data without any filters
    onFetchData(paginationData.page, paginationData.rows, {});
  };

  const buttonData = getIndentsTemplateData(
    () => setOpen(true), { role: userDetails.role.map(r => r.roleName) }
  );

  const handleSearch = () => {
    onFetchData(PAGESTART, PAGESEND, {}, searchText); // Call with search text
  };

  const renderHeader = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "8px",
          gap: "16px",
          width: "100%",
        }}
      >

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
          }}
        >
          {/* Left Side - Buttons */}
          <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
            {buttonData &&
              buttonData.map((val) => <ReusablePrimeButton key={val.label} {...val} />)}
          </div>

        </div>
      </div>
    );
  };


  const handleViewIndent = (indentTemplateId: number) => {
    const userId = userDetails?.userId;
    console.log('User ID:', userId); // Check if userId is valid
    console.log('Indent ID:', indentTemplateId); // Check if indentTemplateId is being passed properly


    setUserId(userId);
    setOpen(true);
  };


  const handleEditIndents = (indentTemplateId: number) => {
    const userId = userDetails?.userId;
    console.log('User ID:', userId); // Check if userId is valid
    console.log('Indent ID:', indentTemplateId); // Check if indentTemplateId is being passed properly

    setIndentTemplateId(indentTemplateId);
    setUserId(userId);
    setOpen(true);
  };

  const projectIds = userDetails?.projectIds ?? [];
  type Filters = {
    [key: string]: {
      value: string[];
    };
  };
  const onFetchData = async (page: number, rows: number, filter?: Filters, searchTerm: string = searchText) => {
    dispatch(setLoading(true));
    try {
      const response = await getIndentsTemplateDataList(page, rows, {});
      const { data, status, pagination } = response;
      if (status.code === 200 && data != null && data?.length > 0) {
        setProducts(response.data);
        setCurrentViewType("all");
        setPaginationData({
          page: pagination.currentPage,
          rows: pagination.limit,
          totalRecords: pagination.totalCount,
        });
      } else {
        setProducts([]);
        //CustomMessage("No data", "error", enqueueSnackbar);
      }
    } catch (error: any) {
      CustomMessage(error?.message, "error", enqueueSnackbar);
    } finally {
      dispatch(setLoading(false));
    }
  };
  console.log("Stage:", selectedStage);
  const header = renderHeader();
  return (
    <div>
      <Box sx={{ mb: 2 }}>
        <h2 style={{ margin: "0 0 12px 8px", fontWeight: 500, fontSize: "18px" }}>
          Indents
        </h2>
      </Box>
      {!open ? (
        <Box
          sx={{
            backgroundColor: "#f9f9f9",
            borderRadius: 3,
            boxShadow: 3,
            padding: 2, // Add padding for better spacing
          }}
        >
          <ReusableDataTable
            ref={dt}
            data={products} // Pass the data array
            columns={columns} // Pass the columns definition
            onFetchData={onFetchData} // Pass the function to fetch data
            emptyMessage="No data found."
            globalFilterFields={[

            ]}
            header={header}
            onRowDoubleClick={(rowData) => {
              console.log('Double-click row:', rowData);
              handleEditIndents(rowData.indentTemplateId);
            }}
            onSelectionChange={(e) => setSelectedProducts(e.value)}
            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
            selection={selectedProducts}
            selectionMode={"multiple"}
            //rowsPerPageOptions={[10, 25, 50, 70, 100]}
            filters={filterData}
            setFilters={setFilterData}
            pagination={paginationData}
            setPagination={setPaginationData}
          />
        </Box>
      ) : (

        <CreatingIndentsTemplate

          setOpen={setOpen}
          userId={userId}
          setIndentTemplateId={setIndentTemplateId}
          indentTemplateId={indentTemplateId}

        />

      )}
    </div>
  );
};



export default IndentsMain;
